<template>
    <div class="pt-10 psform">
        <TwoColumnLayout>
            <template v-slot:banner>
                <Banner :data="getBrandBanner()" :single="true" />
            </template>
            <template v-slot:title>
            </template>
            <template v-slot:filters>
                <div class="row">
                </div>
            </template>
            <template v-slot:form-content>
                <h2 class="mt-4 mt-sm-0">Please enter the information below:</h2>
                <trade-in />
            </template>
            <template v-slot:address>
                <contact-address />
            </template>
        </TwoColumnLayout>
    </div>
</template>
<script>
    import ContactAddress from "../components/molecules/ContactAddress.vue";
    import TwoColumnLayout from "../components/molecules/TwoColumnLayout.vue";
    import TradeIn from "../components/InputForms/TradeIn.vue";
    import Banner from '../components/molecules/CarouselBanner.vue';
    import getBannerData from '../constants/banner.config';
    export default {
        name: "TradeInForm",
        components: {
            ContactAddress,
            TwoColumnLayout,
            TradeIn,
            Banner,
        },
        data() {
            return {
            }
        },
        methods:{
            getBrandBanner(){
                return getBannerData(sessionStorage.getItem('brand'), 'trade_in');
            },
        }
    };
</script>